import { jsx, jsxs } from 'react/jsx-runtime';
import 'luxon';
import 'react';
import styled from 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import Card from '../../atoms/Card/Card.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../icons/InfinityIcon.js';
import '../../icons/ArrowUpRightBoxIcon.js';
import Flex from '../../atoms/layout/Flex/Flex.js';
import '../../atoms/layout/Stack/Stack.js';
import formatNumber from '../../../intl/number/formatNumber.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/Table/Table.js';
import '../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../molecules/CurrencyValue/components/Value.js';
import '../../molecules/KpiCard/KpiCard.js';
import '../../molecules/PercentageValue.js';
import '../../molecules/Tabs/Tabs.js';
import '../../molecules/TrendValue.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../../molecules/Modal/Modal.js';
import ChartKpiValue from './ChartKpiValue.js';
import '../ChartJS.js';
import '../Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';
import ChartKpiPoint from './ChartKpiPoint.js';
import ChartKpiLabel from './ChartKpiLabel.js';

const Point = styled(ChartKpiPoint) `
  background-color: ${(props) => props.$color};
`;
function ChartKpi({ data, valueFormatter, onClick, ...rest }) {
    return (jsx(Flex, { onClick: () => onClick(), ...rest, name: "chartKpi", hover: { cursor: 'pointer' }, children: jsxs(Card, { variant: "chartKpiCard", children: [jsx(Point, { "$color": String(data.backgroundColor || data.borderColor) }), jsxs(ChartKpiLabel, { children: [data.label, ":"] }), jsx(ChartKpiValue, { children: data.data
                        ? valueFormatter
                            ? valueFormatter(Number(data.data.y))
                            : formatNumber(Number(data.data.y))
                        : '–' })] }) }, data.label));
}

export { ChartKpi as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
